// 'this' keyboard must be bind with vue component instance

export default function () {
  const _this = this;
  return {
    save: {
      name: "save",
      title: "Save",
      classes: ['button-green'],
      handlers: {
        async click() {
          if(_this.isAllRequirementPasses()) {
            if (_this.mode === "add") {
              const res = await _this.addData(_this.data.newProfile);
              if (res) {
                alert("Add Completed");
                _this.$router.push(
                  {
                    name: "personal-info-teacher-list"
                  }
                )
              }
            } else if (_this.mode === "edit") {
              const res = await _this.editData(_this.data.newProfile);
              if (res) {
                alert("Update Completed");
                _this.$router.push(
                  {
                    name: "personal-info-teacher-list"
                  }
                )
              }
            }
          } else {
            alert("คุณต้องกรอกข้อมูลสำคัญให้ครบถ้วนก่อน");
          }
        }
      }
    },
    cancel: {
      name: "cancel",
      title: "Cancel",
      classes: ['button-red'],
      handlers: {
        click() {
          _this.resetNewProfile();
          _this.$router.push(
            {
              name: "personal-info-teacher-list"
            }
          )
        }
      }
    }
  }
}
